import { Button, Alert, Text } from "@mantine/core";
import { IconGift, IconId } from "@tabler/icons";
import { MEMBERSHIP_BENEFIT_TYPE } from "../../helpers/config";

/**
 * RedeemBenefitsButton component
 *
 * Props:
 * - hasMembership: boolean - whether the patient has membership
 * - patientName: string - patient's first name
 * - subTotal: number - bill subtotal for validation
 * - onRedeemClick: function - callback when utilize care value button is clicked
 * - disabled: boolean - whether the button should be disabled
 * - showWarning: boolean - whether to show draft warning icon
 * - benefitType: string - membershipSubscription.benefitType; alert shown only when not discounted/regular
 * - subscriptionId: string - membership subscription id for "View plan"
 * - onViewPlan: function(subscriptionId) - callback to open membership status (e.g. modal)
 */
export const RedeemBenefitsButton = ({
  hasMembership,
  patientName,
  subTotal,
  onRedeemClick,
  disabled = false,
  showWarning = false,
  benefitType,
  subscriptionId,
  onViewPlan,
}) => {
  if (!hasMembership) {
    return null;
  }

  const isDiscountedOrRegular =
    benefitType === MEMBERSHIP_BENEFIT_TYPE.DISCOUNTED ||
    benefitType === MEMBERSHIP_BENEFIT_TYPE.REGULAR;
  if (isDiscountedOrRegular) {
    return null;
  }

  return (
    <div className="mt-2">
      <Alert color="teal" variant="light" radius="md">
        <div className="d-flex align-items-center gap-2 justify-content-between flex-wrap">
          <Text size="md">
            <IconGift color="teal" />
            <strong className="ms-1">{patientName}</strong> is a cashless member
            with care value
          </Text>
          <div className="d-flex align-items-center gap-2">
            {subscriptionId && onViewPlan && (
              <Button
                size="sm"
                variant="light"
                color="teal"
                leftIcon={<IconId size={16} />}
                onClick={() => onViewPlan(subscriptionId)}>
                View plan
              </Button>
            )}
            <Button
              size="sm"
              color="teal"
              disabled
              onClick={onRedeemClick}
              leftIcon={<IconGift size={16} />}>
              Use Care Value (Open RampOS)
              {showWarning && (
                <span className="bi bi-exclamation-triangle ms-1 text-warning" />
              )}
            </Button>
          </div>
        </div>
      </Alert>
    </div>
  );
};
